import { useAppContext } from '@contexts/AppContext';

import { useHasMobileAppQuery } from './gql/graphql.v3.generated';

export const useStaticAppsBanner = () => {
  const { isOutlet } = useAppContext();

  const { data, loading } = useHasMobileAppQuery({
    context: {
      batch: true,
      ignoreAuthError: true,
    },
  });

  const isCanShow = (
    !loading
    && !isOutlet
    && !data?.viewer?.hasMobileApp
  );

  return {
    isLoading: loading,
    isCanShow,
  };
};
